import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { api_url, SESSION_TOKEN } from "../Utils/constants.api";

export const loadSessionUser = () => {
  let stringPayload = window.localStorage.getItem(SESSION_TOKEN);
  return stringPayload ?? null;
};

const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${loadSessionUser()}`,
};

export const axiosApiInstance = axios.create({
  baseURL: `${api_url}`,
  headers: {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${loadSessionUser()}`,
  },
  validateStatus: (status) => {
    return status;
  },
});

/**
 *
 * @param {string} url
 * @param {object} payload
 * @param {AxiosRequestConfig} config
 * @returns {Promise<AxiosResponse<any, any>>}
 */
export const postRequest = async (url, payload, config = null) => {
  return axiosApiInstance.post(`${url}`, payload, config);
};

/**
 *
 * @param {string} url
 * @param {AxiosRequestConfig} config
 * @returns {Promise<AxiosResponse<any, any>>}
 */
export const getRequest = async (url, config = null) => {
  return axiosApiInstance.get(`${url}`, config);
};


/**
 *
 * @param {string} url
 * @param {object} payload
 * @param {AxiosRequestConfig} config
 * @returns {Promise<AxiosResponse<any, any>>}
 */
 export const patchRequest = async (url, id, payload, config = null) => {
  return axiosApiInstance.patch(`${url}/${id}`, payload, config);
};
